import { IconHotel, IconQR, IconBell } from './icons';

const FLOW = [
  {
    step: '01',
    icon: IconQR,
    title: 'QR in the room',
    body: 'A unique code — on the bedside card, door hanger, or in-room display — ties every scan to that exact room number. No app download, no login.',
  },
  {
    step: '02',
    icon: IconBell,
    title: 'Guest browses & orders',
    body: 'Full menu, rich photography, dietary tags, modifiers, AI pairings. One tap to place — works on any device, any browser.',
  },
  {
    step: '03',
    icon: IconHotel,
    title: 'Order lands on the dashboard',
    body: "Ticket appears in the Live Order Hub tagged with the room number. Kitchen fires it; front desk sees it; guest tracks it — same platform, new venue.",
  },
];

const POINTS = [
  'Room-level QR — each code resolves to a room, not a table',
  'No app install required — fully browser-native',
  'Live order tracking visible to kitchen and front desk',
  'Loyalty, modifiers and AI suggestions carry over unchanged',
  'Printable QR sheets generated from the same Tables console',
];

export default function Hotel() {
  return (
    <section className="hotel" id="hotel">

      {/* Header */}
      <div className="hotel-header">
        <div className="hotel-header-l">
          <div className="kicker reveal">
            <span className="kicker-dot" />
            <span>Beyond the restaurant</span>
          </div>
          <h2 className="display hotel-title reveal-words">
            Room service,
            <br />
            <em>reinvented.</em>
          </h2>
        </div>
        <div className="hotel-header-r">
          <p className="lede reveal">
            The same QR ordering flow that runs your restaurant floor works
            identically in a hotel room. Place a code on the bedside table —
            guests scan, order, and track delivery without ever picking up the
            room phone.
          </p>
          <div className="hotel-header-meta reveal">
            <span>ZERO NEW INFRASTRUCTURE</span>
            <span>·</span>
            <span>1 PLATFORM</span>
          </div>
        </div>
      </div>

      {/* Flow cards */}
      <div className="hotel-flow">
        {FLOW.map((f) => (
          <div className="hf-card reveal" key={f.step}>
            <div className="hf-top-row">
              <div className="hf-icon-wrap">
                <f.icon />
              </div>
              <span className="hf-step">{f.step}</span>
            </div>
            <h3 className="display hf-title">{f.title}</h3>
            <p className="hf-body">{f.body}</p>
            <div className="hf-connector" aria-hidden="true" />
          </div>
        ))}
      </div>

      {/* Bottom split: visual + point list */}
      <div className="hotel-split">

        {/* Left: tabletop standee */}
        <div className="hotel-visual reveal">
          <div className="standee-scene">
            <div className="standee-card">
              <div className="standee-top">
                <span className="standee-room-num">Room 214</span>
                <span className="standee-badge">OCCUPIED</span>
              </div>
              <div className="standee-divider" />
              <div className="standee-qr-frame">
                <div className="qr-grid">
                  {Array.from({ length: 49 }, (_, i) => (
                    <span key={i} data-on={QR_CELLS[i] ? '1' : undefined} />
                  ))}
                </div>
                <div className="standee-beam" aria-hidden="true" />
              </div>
              <p className="standee-cta">Scan for room service</p>
              <p className="standee-hint">No app · opens in your browser</p>
              <div className="standee-plateera-mark">PLATEERA</div>
            </div>
            <div className="standee-fold" aria-hidden="true" />
            <div className="standee-surface-shadow" aria-hidden="true" />
            <div className="standee-toast">
              <span className="standee-toast-dot" />
              <div className="standee-toast-text">
                <strong>New order · Room 214</strong>
                <span>Club sandwich · OJ · Caesar</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right: feature list */}
        <div className="hotel-points">
          <h3 className="display hotel-points-title reveal-words">
            Same platform.
            <br />
            New <em>venue.</em>
          </h3>
          <ul className="hotel-list">
            {POINTS.map((p) => (
              <li className="reveal" key={p}>
                <span className="hl-dot" />
                {p}
              </li>
            ))}
          </ul>
          <div className="hotel-cta-row reveal">
            <a href="#cta" className="btn btn-primary">Request Access</a>
            <span className="hotel-cta-note">Hotels, resorts, serviced apartments</span>
          </div>
        </div>

      </div>
    </section>
  );
}

/* Minimal 7×7 QR-like bit pattern (decorative, not scannable) */
const QR_CELLS = [
  1,1,1,1,1,1,1,
  1,0,0,0,0,0,1,
  1,0,1,0,1,0,1,
  1,0,0,1,0,0,1,
  1,0,1,0,1,0,1,
  1,0,0,0,0,0,1,
  1,1,1,1,1,1,1,
].map(Boolean);
